import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import Layout from '../components/layout';
import Title from '../components/title';
import './events.css';
import searchIcon from '../assets/search.svg';
import dropdownIcon from '../assets/dropdown.svg';
import editIcon from '../assets/edit.svg';
import deleteIcon from '../assets/delete.svg';

const EVENTS_PER_PAGE = 3;

const Events = () => {
  const [Events, setEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [currentPage, setCurrentPage] = useState(1);
  const [isAddEventOpen, setIsAddEventOpen] = useState(false);
  const [id, setId] = useState('');
  const [editTitle, setEditTitle] = useState('');
  const [editTitleAr, setEditTitleAr] = useState('');
  const [editImageUrl, setEditImageUrl] = useState('');
  const [editCategoryId, setEditCategoryId] = useState('');
  const [editLocationId, setEditLocationId] = useState('');
  const [editPrice, setEditPrice] = useState('');
  const [editDate, setEditDate] = useState('');
  const [editStartTime, setEditStartTime] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editDescriptionAr, setEditDescriptionAr] = useState('');
  const [editIsFeatured, setEditIsFeatured] = useState(false);
  const [editTicketsLeft, setEditTicketsLeft] = useState('');
  const [isEditEventOpen, setIsEditEventOpen] = useState(false);

  const [title, setTitle] = useState('');
  const [titleAr, setTitleAr] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [locationId, setLocationId] = useState('');
  const [price, setPrice] = useState('');
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [description, setDescription] = useState('');
  const [descriptionAr, setDescriptionAr] = useState('');
  const [isFeatured, setIsFeatured] = useState(false);
  const [ticketsLeft, setTicketsLeft] = useState('');

  const fetchEvents = async () => {
    const res = await supabase
      .from("Events")
      .select(`
        *,
        Categories(name, name_ar),
        Locations(venue_name, venue_name_ar, address, address_ar, city, city_ar)
      `);

    setEvents(res.data);
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const createEvent = async (e) => {
    e.preventDefault();

    const { error } = await supabase.from("Events").insert([{
      title: title,
      title_ar: titleAr,
      image_url: imageUrl,
      category_id: categoryId ? Number(categoryId) : null,
      location_id: locationId ? Number(locationId) : null,
      price: price,
      date: date,
      start_time: startTime,
      description: description,
      description_ar: descriptionAr,
      is_featured: isFeatured,
      tickets_left: ticketsLeft ? Number(ticketsLeft) : null,
    }]);

    if (error) {
      alert("Failed to create event: " + error.message);
      return;
    }

    await fetchEvents();

    setTitle('');
    setTitleAr('');
    setImageUrl('');
    setCategoryId('');
    setLocationId('');
    setPrice('');
    setDate('');
    setStartTime('');
    setDescription('');
    setDescriptionAr('');
    setIsFeatured(false);
    setTicketsLeft('');

    setIsAddEventOpen(false);
  };

  const editEvent = (event) => {
    setId(event.id);
    setEditTitle(event.title);
    setEditTitleAr(event.title_ar);
    setEditImageUrl(event.image_url);
    setEditCategoryId(event.category_id);
    setEditLocationId(event.location_id);
    setEditPrice(event.price);
    setEditDate(event.date);
    setEditStartTime(event.start_time);
    setEditDescription(event.description);
    setEditDescriptionAr(event.description_ar);
    setEditIsFeatured(event.is_featured);
    setEditTicketsLeft(event.tickets_left);
    setIsEditEventOpen(true);
  };

  const updateEvent = async (e) => {
    e.preventDefault();

    await supabase
      .from("Events")
      .update({
        title: editTitle,
        title_ar: editTitleAr,
        image_url: editImageUrl,
        category_id: editCategoryId ? Number(editCategoryId) : null,
        location_id: editLocationId ? Number(editLocationId) : null,
        price: editPrice,
        date: editDate,
        start_time: editStartTime,
        description: editDescription,
        description_ar: editDescriptionAr,
        is_featured: editIsFeatured,
        tickets_left: editTicketsLeft ? Number(editTicketsLeft) : null,
      })
      .eq('id', id);

    await fetchEvents();
    setIsEditEventOpen(false);
  };

  const deleteEvent = async (id) => {
    await supabase.from("Events").delete().eq('id', id);
    await fetchEvents();
  };

  const handleFeaturedToggle = async (eventId, currentValue) => {
    const nextValue = !currentValue;

    await supabase
      .from('Events')
      .update({ is_featured: nextValue })
      .eq('id', eventId);

    setEvents((currentEvents) =>
      currentEvents.map((event) =>
        event.id === eventId
          ? { ...event, is_featured: nextValue }
          : event
      )
    );
  };

  const handleTrendingToggle = async (eventId, currentValue) => {
    const nextValue = !currentValue;

    await supabase
      .from('Events')
      .update({ is_trending: nextValue })
      .eq('id', eventId);

    setEvents((currentEvents) =>
      currentEvents.map((event) =>
        event.id === eventId
          ? { ...event, is_trending: nextValue }
          : event
      )
    );
  };

  const handlePopularToggle = async (eventId, currentValue) => {
    const nextValue = !currentValue;

    await supabase
      .from('Events')
      .update({ is_popular: nextValue })
      .eq('id', eventId);

    setEvents((currentEvents) =>
      currentEvents.map((event) =>
        event.id === eventId
          ? { ...event, is_popular: nextValue }
          : event
      )
    );
  };

  const handleShowTicketsLeftToggle = async (eventId, currentValue) => {
    const nextValue = !currentValue;

    await supabase
      .from('Events')
      .update({ show_tickets_left: nextValue })
      .eq('id', eventId);

    setEvents((currentEvents) =>
      currentEvents.map((event) =>
        event.id === eventId
          ? { ...event, show_tickets_left: nextValue }
          : event
      )
    );
  };

  const categoryOptions = [...new Set(Events.filter((event) => event.Categories).map((event) => event.Categories.name))];

  const categoryOptionsWithId = Events.reduce((acc, event) => {
    if (event.Categories && !acc.find((c) => c.id === event.category_id)) {
      acc.push({ id: event.category_id, name: event.Categories.name });
    }
    return acc;
  }, []);

  const locationOptionsWithId = Events.reduce((acc, event) => {
    if (event.Locations && !acc.find((l) => l.id === event.location_id)) {
      acc.push({ id: event.location_id, name: event.Locations.venue_name });
    }
    return acc;
  }, []);

  const filteredEvents = Events.filter((event) => {
    const value = searchTerm.toLowerCase();
    const matchesCategory =
      selectedCategory === 'All Categories' ||
      event.Categories?.name === selectedCategory;

    const matchesSearch = (
      event.id.toString().includes(value) ||
      event.title?.toLowerCase().includes(value) ||
      event.title_ar?.toLowerCase().includes(value) ||
      event.description?.toLowerCase().includes(value) ||
      event.description_ar?.toLowerCase().includes(value) ||
      event.Categories?.name?.toLowerCase().includes(value) ||
      event.Locations?.venue_name?.toLowerCase().includes(value)
    );

    return matchesSearch && matchesCategory;
  });

  const totalPages = Math.ceil(filteredEvents.length / EVENTS_PER_PAGE);
  const startIndex = (currentPage - 1) * EVENTS_PER_PAGE;
  const paginatedEvents = filteredEvents.slice(startIndex, startIndex + EVENTS_PER_PAGE);


  return (
    <Layout>
      <div className="events_page">
        <Title
          subtitle="Manage all events on the Eventra platform"
          title="EVENTS MANAGEMENT"
        />

        <div className="events_controls_card">
          <div className="events_controls_left">
            <label className="events_search" htmlFor="events-search">
              <img alt="" src={searchIcon} />
              <input
                id="events-search"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="Search events..."
                type="text"
                value={searchTerm}
              />
            </label>

            <div className="events_filter">
              <select
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setCurrentPage(1);
                }}
                value={selectedCategory}
              >
                <option value="All Categories">All Categories</option>
                {categoryOptions.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
              <img alt="" src={dropdownIcon} />
            </div>
          </div>

          <button
            className="events_add_button"
            onClick={() => setIsAddEventOpen(true)}
            type="button"
          >
            <div>+</div>
            <div>Add Event</div>
          </button>
        </div>

        <div className="events_table_card">
          <div className="events_table_top">
            <div className="events_table_title">All Events</div>
            <div className="events_table_count">{filteredEvents.length} total events</div>
          </div>

          <div className="events_table_scroll">
            <div className="events_row events_table_head">
              <div className="events_checkbox">
                <input type="checkbox" />
              </div>
              <div>ID</div>
              <div>Created At</div>
              <div>Event</div>
              <div>Description</div>
              <div>Date</div>
              <div>Start</div>
              <div>End</div>
              <div>Image</div>
              <div>Price</div>
              <div>Featured</div>
              <div>Trending</div>
              <div>Category</div>
              <div>Location</div>
              <div>Popular</div>
              <div>Tickets Left</div>
              <div>Show On Website</div>
              <div>Actions</div>
            </div>

            <div className="events_table_body">
              {paginatedEvents.map((event) => (
                <div className="events_row" key={event.id}>
                  <div className="events_checkbox">
                    <input type="checkbox" />
                  </div>

                  <div className="events_cell_text">{event.id}</div>
                  <div className="events_cell_text">{event.created_at}</div>

                  <div className="events_event_info">
                    <div className="events_event_thumb">
                      <img alt="" src={event.image_url} />
                    </div>

                    <div className="events_event_text">
                      <div className="events_event_name">{event.title}</div>
                      <div className="events_event_subtitle">{event.title_ar}</div>
                    </div>
                  </div>

                  <div className="events_cell_stack">
                    <div className="events_cell_text">{event.description}</div>
                    <div className="events_cell_subtext">{event.description_ar}</div>
                  </div>
                  <div className="events_cell_text">{event.date}</div>
                  <div className="events_cell_text">{event.start_time}</div>
                  <div className="events_cell_text">{event.end_time}</div>

                  <div className="events_image_url">{event.image_url}</div>
                  <div className="events_cell_text">{event.price}</div>

                  <button
                    className={`events_toggle ${event.is_featured ? 'is_on' : ''}`}
                    onClick={() => handleFeaturedToggle(event.id, event.is_featured)}
                  >
                    <span className="events_toggle_thumb" />
                  </button>
                  <button
                    className={`events_toggle ${event.is_trending ? 'is_on' : ''}`}
                    onClick={() => handleTrendingToggle(event.id, event.is_trending)}
                  >
                    <span className="events_toggle_thumb" />
                  </button>
                  <div className="events_cell_text">{event.Categories?.name}</div>
                  <div className="events_cell_text">{event.Locations?.venue_name}</div>
                  <button
                    className={`events_toggle ${event.is_popular ? 'is_on' : ''}`}
                    onClick={() => handlePopularToggle(event.id, event.is_popular)}
                  >
                    <span className="events_toggle_thumb" />
                  </button>
                  <div className="events_cell_text">{event.tickets_left} left</div>
                  <button
                    className={`events_toggle ${event.show_tickets_left ? 'is_on' : ''}`}
                    onClick={() =>
                      handleShowTicketsLeftToggle(event.id, event.show_tickets_left)
                    }
                  >
                    <span className="events_toggle_thumb" />
                  </button>

                  <div className="events_actions">
                    <button
                      className="events_action_button"
                      onClick={() => editEvent(event)}
                      type="button"
                    >
                      <img alt="" src={editIcon} />
                    </button>
                    <button className="events_action_button" onClick={() => deleteEvent(event.id)}>
                      <img alt="" src={deleteIcon} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {totalPages > 1 && (
            <div className="events_pagination">
              <button
                className="events_pagination_button"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              <div className="events_pagination_info">
                Page {currentPage} of {totalPages}
              </div>
              <button
                className="events_pagination_button"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>

        {isAddEventOpen && (
          <div
            className="events_modal_overlay"
            onClick={() => setIsAddEventOpen(false)}
            role="presentation"
          >
            <div
              aria-modal="true"
              className="events_modal"
              onClick={(event) => event.stopPropagation()}
              role="dialog"
            >
              <div className="events_modal_header">
                <div className="events_modal_heading">
                  <h2>ADD NEW EVENT</h2>
                  <p>
                    Fill in the details below to create a new event. All fields support
                    bilingual content.
                  </p>
                </div>

                <button
                  aria-label="Close add event overlay"
                  className="events_modal_close"
                  onClick={() => setIsAddEventOpen(false)}
                  type="button"
                >
                  x
                </button>
              </div>

              <form
                className="events_modal_form"
                onSubmit={createEvent}
              >
                <div className="events_modal_grid">
                  <label className="events_modal_field">
                    <span>Title (English)</span>
                    <input
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Event title in English"
                      type="text"
                      value={title}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Title (Arabic)</span>
                    <input
                      dir="rtl"
                      onChange={(e) => setTitleAr(e.target.value)}
                      placeholder="عنوان الفعالية باللغة العربية"
                      type="text"
                      value={titleAr}
                    />
                  </label>

                  <label className="events_modal_field events_modal_field_full">
                    <span>Event Image URL</span>
                    <input
                      onChange={(e) => setImageUrl(e.target.value)}
                      placeholder="https://example.com/image.jpg"
                      type="text"
                      value={imageUrl}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Category</span>
                    <div className="events_modal_select_wrap">
                      <select
                        onChange={(e) => setCategoryId(e.target.value)}
                        value={categoryId}
                      >
                        <option value="">Select category</option>
                        {categoryOptionsWithId.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))}
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <label className="events_modal_field">
                    <span>Price</span>
                    <input
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="0.00"
                      type="text"
                      value={price}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Date</span>
                    <input
                      onChange={(e) => setDate(e.target.value)}
                      type="date"
                      value={date}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Time</span>
                    <input
                      onChange={(e) => setStartTime(e.target.value)}
                      placeholder="--:-- --"
                      type="text"
                      value={startTime}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Location</span>
                    <div className="events_modal_select_wrap">
                      <select
                        onChange={(e) => setLocationId(e.target.value)}
                        value={locationId}
                      >
                        <option value="">Select location</option>
                        {locationOptionsWithId.map((loc) => (
                          <option key={loc.id} value={loc.id}>
                            {loc.name}
                          </option>
                        ))}
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <div className="events_modal_field">
                    <span>Featured</span>
                    <button
                      className={`events_toggle ${isFeatured ? 'is_on' : ''}`}
                      onClick={() => setIsFeatured(!isFeatured)}
                      type="button"
                    >
                      <span className="events_toggle_thumb" />
                    </button>
                  </div>

                  <label className="events_modal_field">
                    <span>Tickets Left</span>
                    <input
                      onChange={(e) => setTicketsLeft(e.target.value)}
                      placeholder="0"
                      type="number"
                      value={ticketsLeft}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Description (English)</span>
                    <textarea
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Event description in English"
                      rows="3"
                      value={description}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Description (Arabic)</span>
                    <textarea
                      dir="rtl"
                      onChange={(e) => setDescriptionAr(e.target.value)}
                      placeholder="وصف الفعالية باللغة العربية"
                      rows="3"
                      value={descriptionAr}
                    />
                  </label>
                </div>

                <div className="events_modal_actions">
                  <button
                    className="events_modal_secondary_button"
                    onClick={() => setIsAddEventOpen(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button className="events_modal_primary_button" type="submit">
                    Create Event
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {isEditEventOpen && (
          <div
            className="events_modal_overlay"
            onClick={() => setIsEditEventOpen(false)}
            role="presentation"
          >
            <div
              aria-modal="true"
              className="events_modal"
              onClick={(event) => event.stopPropagation()}
              role="dialog"
            >
              <div className="events_modal_header">
                <div className="events_modal_heading">
                  <h2>EDIT EVENT</h2>
                  <p>Update the event details below.</p>
                </div>

                <button
                  aria-label="Close edit event overlay"
                  className="events_modal_close"
                  onClick={() => setIsEditEventOpen(false)}
                  type="button"
                >
                  x
                </button>
              </div>

              <form
                className="events_modal_form"
                onSubmit={updateEvent}
              >
                <div className="events_modal_grid">
                  <label className="events_modal_field">
                    <span>Title (English)</span>
                    <input
                      onChange={(e) => setEditTitle(e.target.value)}
                      type="text"
                      value={editTitle}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Title (Arabic)</span>
                    <input
                      dir="rtl"
                      onChange={(e) => setEditTitleAr(e.target.value)}
                      type="text"
                      value={editTitleAr}
                    />
                  </label>

                  <label className="events_modal_field events_modal_field_full">
                    <span>Event Image URL</span>
                    <input
                      onChange={(e) => setEditImageUrl(e.target.value)}
                      type="text"
                      value={editImageUrl}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Category</span>
                    <div className="events_modal_select_wrap">
                      <select
                        onChange={(e) => setEditCategoryId(e.target.value)}
                        value={editCategoryId}
                      >
                        <option value="">Select category</option>
                        {categoryOptionsWithId.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))}
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <label className="events_modal_field">
                    <span>Price</span>
                    <input
                      onChange={(e) => setEditPrice(e.target.value)}
                      type="text"
                      value={editPrice}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Date</span>
                    <input
                      onChange={(e) => setEditDate(e.target.value)}
                      type="date"
                      value={editDate}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Time</span>
                    <input
                      onChange={(e) => setEditStartTime(e.target.value)}
                      type="text"
                      value={editStartTime}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Location</span>
                    <div className="events_modal_select_wrap">
                      <select
                        onChange={(e) => setEditLocationId(e.target.value)}
                        value={editLocationId}
                      >
                        <option value="">Select location</option>
                        {locationOptionsWithId.map((loc) => (
                          <option key={loc.id} value={loc.id}>
                            {loc.name}
                          </option>
                        ))}
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <div className="events_modal_field">
                    <span>Featured</span>
                    <button
                      className={`events_toggle ${editIsFeatured ? 'is_on' : ''}`}
                      onClick={() => setEditIsFeatured(!editIsFeatured)}
                      type="button"
                    >
                      <span className="events_toggle_thumb" />
                    </button>
                  </div>

                  <label className="events_modal_field">
                    <span>Tickets Left</span>
                    <input
                      onChange={(e) => setEditTicketsLeft(e.target.value)}
                      type="number"
                      value={editTicketsLeft}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Description (English)</span>
                    <textarea
                      onChange={(e) => setEditDescription(e.target.value)}
                      rows="3"
                      value={editDescription}
                    />
                  </label>

                  <label className="events_modal_field">
                    <span>Description (Arabic)</span>
                    <textarea
                      dir="rtl"
                      onChange={(e) => setEditDescriptionAr(e.target.value)}
                      rows="3"
                      value={editDescriptionAr}
                    />
                  </label>
                </div>

                <div className="events_modal_actions">
                  <button
                    className="events_modal_secondary_button"
                    onClick={() => setIsEditEventOpen(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button className="events_modal_primary_button" type="submit">
                    Update Event
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Events;
